// extracted by mini-css-extract-plugin
export var button = "_p-0";
export var buttonContent = "_p-e";
export var buttonGroup = "_p-c";
export var dontRestrainIconWidth = "_p-a";
export var dropdownButton = "_p-b";
export var iconContainer = "_p-9";
export var lg = "_p-4";
export var md = "_p-3";
export var pending = "_p-f";
export var sm = "_p-2";
export var spinner = "_p-d";
export var squared = "_p-8";
export var wrapText = "_p-g";
export var xl = "_p-5";
export var xs = "_p-1";
export var xxl = "_p-6";
export var xxxl = "_p-7";